import type { APIClient } from '@src/corelib/api';
import { prefetchBaseQuery } from '@src/corelib/query';
import type { BuildQueryDescriptorParams } from '@src/corelib/query/utils';

export default function prefetchQuery(url: string, client: APIClient, params?: BuildQueryDescriptorParams) {
  return prefetchBaseQuery(url, client, params);
}
